import { Link } from '../lib/router';

export default function NotFound() {
  return (
    <div className="state state--empty">
      <h2>404</h2>
      <p>Page not found.</p>
      <Link to="/food-preferences" className="btn btn--primary">Go home</Link>
    </div>
  );
}
